import Vue from 'vue';
import signalR from 'signalr';

Vue.prototype.$signalR = signalR;

// Authentication goes through the access_token query string (accepted by the API only on /signalr),
// so browser credentials (cookies) are never needed.
// jQuery SignalR defaults withCredentials to true on cross-domain connections unless it is passed on every start().
export function createLegacyHubConnection(apiUrl, token) {
    const connection = $.hubConnection(apiUrl);
    connection.qs = { access_token: token };

    const originalStart = connection.start;
    connection.start = function (options, callback) {
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        return originalStart.call(this, Object.assign({}, options, { withCredentials: false }), callback);
    };

    return connection;
}
